import { Icon } from './Icon'
import type { Ticket } from '../domain/types'
import { isPending } from '../domain/engine'

// Previsão de atendimento por bilhete — comportamento #7.
// No mock calculamos agora+estMin (re-renderiza com o tick → parece "ao vivo").
// No RealDataSource, `ticket.prevision` virá do servidor (PrevisionChanged).
export function previsaoLocal(estMin: number): string {
  const d = new Date(Date.now() + estMin * 60000)
  return `${String(d.getHours()).padStart(2, '0')}:${String(d.getMinutes()).padStart(2, '0')}`
}

export function PrevisionBadge({ ticket }: { ticket: Ticket }) {
  if (!isPending(ticket.status)) {return null}
  const time = ticket.prevision ?? previsaoLocal(ticket.estMin)
  return (
    <span className="fz-prevision" title="Previsão de atendimento">
      <Icon name="clock" size={12} /> previsto ~{time}
    </span>
  )
}
